import { LUDUM_INTENSITIES, LUDUM_SPORTS } from '@/constants';

export function intensityClass(intensityId) {
    switch (Number(intensityId)) {
        case LUDUM_INTENSITIES.UT1:
            return 'ut1';
        case LUDUM_INTENSITIES.UT2:
            return 'ut2';
        case LUDUM_INTENSITIES.UT3:
            return 'ut3';
        case LUDUM_INTENSITIES.AT:
            return 'at';
        case LUDUM_INTENSITIES.TR:
            return 'tr';
        case LUDUM_INTENSITIES.LACTATE_TOLERANCE:
            return 'lt';
        case LUDUM_INTENSITIES.A_LACT:
            return 'a-lact';
        default:
            return '';
    }
}

export function sportIconClass(sportId) {
    switch (sportId) {
        case LUDUM_SPORTS.ROWING:
            return 'icon-rowing';
        case LUDUM_SPORTS.KAYAK_CANOE:
            return 'icon-kayak-canoe';
        case LUDUM_SPORTS.ERGO:
            return 'icon-ergo';
        case LUDUM_SPORTS.SC:
            return 'icon-sc';
        case LUDUM_SPORTS.DAY_OFF:
            return 'icon-day-off';
        case LUDUM_SPORTS.BIKE:
            return 'icon-bike';
        case LUDUM_SPORTS.RUN:
            return 'icon-run';
        case LUDUM_SPORTS.SWIM:
            return 'icon-swimming';
        case LUDUM_SPORTS.OTHER:
            return 'icon-other';
        default:
            return 'icon-event';
    }
}

export function isBikeSession(sportId) {
    return Number(sportId) === LUDUM_SPORTS.BIKE;
}

export function isErgoSession(sportId) {
    return Number(sportId) === LUDUM_SPORTS.ERGO;
}

export function isRunSession(sportId) {
    return Number(sportId) === LUDUM_SPORTS.RUN;
}

export function isScSession(sportId) {
    return Number(sportId) === LUDUM_SPORTS.SC;
}

export function isSwimSession(sportId) {
    return Number(sportId) === LUDUM_SPORTS.SWIM;
}

export function isWaterSession(sportId) {
    return isRowingSession(sportId) || isKayakCanoeSession(sportId);
}

export function isRowingSession(sportId) {
    return Number(sportId) === LUDUM_SPORTS.ROWING;
}

export function isKayakCanoeSession(sportId) {
    return Number(sportId) === LUDUM_SPORTS.KAYAK_CANOE;
}

export function isMultisportSession(sportId) {
    return Number(sportId) === LUDUM_SPORTS.MULTISPORT;
}

export function isDayOffSession(sportId) {
    return Number(sportId) === LUDUM_SPORTS.DAY_OFF;
}

export function isOtherSession(sportId) {
    return Number(sportId) === LUDUM_SPORTS.OTHER;
}
